module.exports = __webpack_public_path__ + "hero-mobile.png?be13bbf1945dfb04b019e722105fc756";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero-mobile.png
// module id = 122
// module chunks = 0